/**
 *
 *
 */

import RiskFactor from './risk-factor';

export default class RiskScore extends RiskFactor {
    icon = 'eye';

    label = 'Risk Score';

    static getCondition({riskScore}) {
        return riskScore !== undefined && riskScore >= 0;
    }

    parse({riskScore}) {
        this.riskScore = riskScore;
    }

    getResult() {
        return this.riskScore;
    }
}
